import { alpha, Box, Grid, styled, Typography } from '@mui/material';

export const HoverMenu = styled(Box)(({ theme }) => ({
    background: theme.custom.c3,
    width: 'max-content',
    position: 'absolute',
    bottom: '100%',
    overflow: 'hidden',
    display: 'inline-flex',
    padding: '16px',
    borderRadius: '16px',
    gap: '8px',
    zIndex: 1000,
}));

export const TwoArrowGrid = styled(Grid)(({ theme: _theme }) => ({
    width: '48px',
    height: '48px',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    borderRadius: '8px 0 0 8px',
}));

export const NameProfileText = styled(Typography)(({ theme }) => ({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: theme.palette.primary.contrastText,
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
}));

export const HeaderText = styled(Typography)(({ theme }) => ({
    color: alpha(theme.custom.c18, 0.4),
    fontSize: '0.625rem',
    fontWeight: 700,
    textTransform: 'uppercase',
}));
